import type { EnhancedPoisResponse } from "./types";

export const enhancedPoisKeys = {
  all: () => ["enhancedPois"] as const,
  list: (filters: Partial<EnhancedPoisResponse>) =>
    [...enhancedPoisKeys.all(), filters] as const,
};
